/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it simplify the answer?`)
};

const es_fr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Simplifica el resultado?`)
};

const de_fr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird das Ergebnis gekürzt?`)
};

const nl_fr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt het antwoord vereenvoudigd?`)
};

const fr_fr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le résultat est-il simplifié ?`)
};

const it_fr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semplifica il risultato?`)
};

const pt_br2_fr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela simplifica a resposta?`)
};

const pt_fr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simplifica a resposta?`)
};

const ja_fr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`答えは約分されますか?`)
};

const zh_fr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结果会自动化简吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq_q3", locale)
	if (locale === "en") return en_fr_faq_q3(inputs)
	if (locale === "es") return es_fr_faq_q3(inputs)
	if (locale === "de") return de_fr_faq_q3(inputs)
	if (locale === "nl") return nl_fr_faq_q3(inputs)
	if (locale === "fr") return fr_fr_faq_q3(inputs)
	if (locale === "it") return it_fr_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq_q3(inputs)
	if (locale === "pt") return pt_fr_faq_q3(inputs)
	if (locale === "ja") return ja_fr_faq_q3(inputs)
	return zh_fr_faq_q3(inputs)
};